import { GraphUtils } from '@helpers/graph.helper';
import { Sensor, dataChart } from './sensor';
import { Router } from '@angular/router';

export class PulseSensor extends Sensor {
  public waterHourGraph: any;
  public waterGraph: any;
  public waterMonthGraph: any;

  private waterHourSensor: any[];
  private waterSensor: any[];
  private waterMonthSensor: any[];
  private lastWaterRegister: any[];
  private equivalenceByPosition: number[];

  constructor(router: Router, url: string, alerstActive: boolean) {
    super(router, url, alerstActive);
    this.waterGraph = null;

    this.waterSensor = [[], [], []];
    this.waterMonthSensor = [[], [], []];
    this.waterHourSensor = [[], [], []];
    this.lastWaterRegister = [null, null, null];
    this.equivalenceByPosition = [1, 1, 1];
  }

  public hasHourWaterSensor(pos: number): boolean {
    return this.waterHourSensor[pos - 1].length > 0;
  }

  public getHourWaterSensor(pos: number): any {
    const realPos: number = this.waterHourSensor[pos - 1].length - 1;
    return this.waterHourSensor[pos - 1][realPos][1] ?? null;
  }

  public hasWaterSensor(pos: number): boolean {
    return this.waterSensor[pos - 1].length > 0;
  }

  public getWaterSensor(pos: number): any {
    const realPos: number = this.waterSensor[pos - 1].length - 1;
    return this.waterSensor[pos - 1][realPos][1] ?? null;
  }

  public hasMonthWaterSensor(pos: number): boolean {
    return this.waterMonthSensor[pos - 1].length > 0;
  }

  public getMonthWaterSensor(pos: number): any {
    const realPos: number = this.waterMonthSensor[pos - 1].length - 1;
    return this.waterMonthSensor[pos - 1][realPos][1] ?? null;
  }

  public hasWaterRegister(pos: number): boolean {
    const index = pos - 1;
    return this.lastWaterRegister[index] !== undefined && this.lastWaterRegister[index] !== null;
  }

  public getWaterRegister(pos: number): any {
    return this.lastWaterRegister[pos - 1] ?? null;
  }

  public getDisplayWaterValue(value: number, pos: number): number {
    const equivalence = this.getEquivalence(pos);

    if (value === null || value === undefined) {
      return value;
    }

    return equivalence > 0 && equivalence < 1 ? value * 1000 : value;
  }

  public getDisplayWaterUnit(pos: number): string {
    const equivalence = this.getEquivalence(pos);

    return equivalence > 0 && equivalence < 1 ? 'L' : 'm3';
  }

  private getEquivalence(pos: number): number {
    return this.equivalenceByPosition[pos - 1] ?? 1;
  }

  private applyPulseTooltipFormat(graph: any): void {
    graph.tooltip = {
      ...graph.tooltip,
      pointFormatter: function () {
        const value = Number(this.y ?? 0).toLocaleString('es-ES', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 3,
        });

        return `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${value}</b><br/>`;
      }
    };
  }

  public prepareData(): void {
    const lastDate = this.data[this.data.length - 1]?.date;
    const lastPacketPositions = new Set<number>();

    for (const element of this.data) {
      if (element.date === lastDate) {
        lastPacketPositions.add(element.position);
      }
    }

    this.lastWaterRegister = this.lastWaterRegister.map((_, index) => {
      return lastPacketPositions.has(index) ? null : undefined;
    });

    for (const element of this.data) {
      if (element.equivalence !== null && element.equivalence !== undefined) {
        this.equivalenceByPosition[element.position] = Number(element.equivalence);
      }

      if (element.date === lastDate && element.waterRegister !== null && element.waterRegister !== undefined) {
        this.lastWaterRegister[element.position] = element.waterRegister;
      }

      // Day
      const date = new Date(element.date);
      let currentVal = this.waterSensor[element.position].find((e) => e[0] == GraphUtils.getDay(date));
      if (currentVal) {
        currentVal[1] += element.water;
      } else {
        this.waterSensor[element.position].push([
          GraphUtils.getDay(date),
          element.water,
        ]);
      }
      // Month
      const date2 = new Date(element.date);
      let currentVal2 = this.waterMonthSensor[element.position].find((e) => e[0] == GraphUtils.getMoth(date2));
      if (currentVal2) {
        currentVal2[1] += element.water;
      } else {
        this.waterMonthSensor[element.position].push([
          GraphUtils.getMoth(date2),
          element.water,
        ]);
      }
      // Hour
      const date3 = new Date(element.date);
      let currentVal3 = this.waterHourSensor[element.position].find((e) => e[0] == GraphUtils.getHour(date3));
      if (currentVal3) {
        currentVal3[1] += element.water;
      } else {
        this.waterHourSensor[element.position].push([
          GraphUtils.getHour(date3),
          element.water,
        ]);
      }
    }
  }

  public setCharts(): void {
    this.waterGraph = this.getConfigChar(
      'pulse',
      this.getChartSeries('Sensor ', this.waterSensor),
      this.getRanges('8_value_daily'),
      this.getLimits('8_value_daily'),
      'column'
    );
    this.applyPulseTooltipFormat(this.waterGraph);

    this.waterHourGraph = this.getConfigChar(
      'pulseHour',
      this.getChartSeries('Sensor ', this.waterHourSensor),
      this.getRanges('8_value_hour'),
      this.getLimits('8_value_hour'),
      'column'
    );
    this.applyPulseTooltipFormat(this.waterHourGraph);

    this.waterMonthGraph = this.getConfigChar(
      'pulseMonth',
      this.getChartSeries('Sensor ', this.waterMonthSensor),
      this.getRanges('8_value_monthly'),
      this.getLimits('8_value_monthly'),
      'column'
    );
    this.applyPulseTooltipFormat(this.waterMonthGraph);
  }

  public static getVariables(): any[] {
    return [
      { title: 'Consumo de agua hora', value: '8_value_hour' },
      { title: 'Consumo de agua dia', value: '8_value_daily' },
      { title: 'Consumo de agua mes', value: '8_value_monthly' }
    ];
  }
}
